/** Max rows for client-side PDF export (aligned with server AlertLimitPerReport). */
export const PDF_EXPORT_MAX_ROWS = 5000;

/** Above this count, user must confirm before generating PDF. */
export const PDF_EXPORT_WARN_ROWS = 500;

/** CSV column labels (English literals; angular2-csv uses object property names). */
export const ALERT_EXPORT_HEADERS = [
  'Start time',
  'Device',
  'Alert type',
  'User',
  'End time',
  'Additional presses count',
] as const;

export const CAMERA_EXPORT_HEADERS = [
  'Start time',
  'Device',
  'Type of visit',
  'User',
  'End time',
] as const;

export const LOCK_EXPORT_HEADERS = [
  'Timestamp',
  'Device',
  'Event',
  'User',
] as const;

/** i18n keys for PDF table headers (aligned with report table columns). */
export const ALERT_PDF_HEADER_KEYS = [
  'START_TIME',
  'DEVICE',
  'EVENT',
  'USER_OR_RECIPIENT',
  'END_TIME',
  'ADDITIONAL_PRESSES_DURING_ALERT',
] as const;

export const CAMERA_PDF_HEADER_KEYS = [
  'START_TIME',
  'DEVICE',
  'VISIT_TYPE',
  'USER_OR_RECIPIENT',
  'END_TIME',
] as const;

export const LOCK_PDF_HEADER_KEYS = [
  'TIMESTAMP',
  'DEVICE',
  'EVENT',
  'USER_OR_RECIPIENT',
] as const;

/** Minimal alert fields for CSV export (flat row mapping only). */
export const ALERT_CSV_FIELD_FILTER = [
  'receiveTime',
  'deviceName',
  'activationGroup',
  'activationNode',
  'deviceType',
  'customActivationName',
  'connTimeLimit',
  'resolverName',
  'completeTime',
  'additionalPresses',
] as const;

/** Expanded alert fields for JSON and enriched PDF export. */
export const ALERT_DETAIL_FIELD_FILTER = [
  ...ALERT_CSV_FIELD_FILTER,
  'taskId',
  'createTime',
  'deviceId',
  'environmentName',
  'environmentId',
  'deliveryType',
  'emaEvents',
  'callEvents',
  'commentEvents',
  'cancelled',
  'smsEvents',
  'emailEvents',
  'alertRouterId',
  'alertRouterName',
  'confirmed',
  'alarmReasons',
  'pausedDevices',
  'visitOnAlertStarted',
  'receivedBy',
  'details',
] as const;
